import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Dotcom2024Service } from '../dotcom2024.service';

@Component({
  selector: 'app-blogsbymarketpage',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './blogsbymarketpage.component.html',
  styleUrl: './blogsbymarketpage.component.css'
})
export class BlogsbymarketpageComponent {

  featuredBlogs: any[] = [];
  featuredBlog1ImageName: string = "";
  featuredBlog2ImageName: string = "";
  featuredBlog3ImageName: string = "";
  featuredBlog1Title: string = "";
  featuredBlog2Title: string = "";
  featuredBlog3Title: string = "";
  featuredBlog1Summary: string = "";
  featuredBlog2Summary: string = "";
  featuredBlog3Summary: string = "";
  featuredBlog1ItemAlias: string = "";
  featuredBlog2ItemAlias: string = "";
  featuredBlog3ItemAlias: string = "";

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";

  constructor(public dotComService: Dotcom2024Service) {
  }

  ngOnInit(): void {
    console.log(this.dotComService.activePage);
    this.GetFeaturedBlogsToDisplay(this.dotComService.activePage);

  }

  GoToBlogInNewTab(blogAlias: any) {
    window.open('/blog?id=' + blogAlias, '_blank');
  }

  GetFeaturedBlogsToDisplay(marketPage: string) {
    this.featuredBlogs = []
    this.dotComService.GetMarketsFeaturedBlogs(marketPage).subscribe((data: any) => {
      this.featuredBlogs = data;
      this.PopulateFeaturedBlogVariables();
    })
  }

  PopulateFeaturedBlogVariables() {
    this.featuredBlog1Title = ""
    this.featuredBlog2Title = ""
    this.featuredBlog3Title = ""
    this.featuredBlog1ItemAlias = ""
    this.featuredBlog2ItemAlias = ""
    this.featuredBlog3ItemAlias = ""
    this.featuredBlog1Summary = ""
    this.featuredBlog2Summary = ""  
    this.featuredBlog3Summary = ""

    for (let i = 0; i < this.featuredBlogs.length; i++) {
      if (this.featuredBlog1Title == "") {
        this.featuredBlog1Title = this.featuredBlogs[i].Title;
        this.featuredBlog1Summary = this.featuredBlogs[i].Summary;
        this.featuredBlog1ItemAlias = this.featuredBlogs[i].ItemAlias;

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            this.featuredBlog1ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
              if (exists) {
                // Success code
                this.featuredBlog1ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
              } else {
                // Fail code - use default
                this.featuredBlog1ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });


      } else if (this.featuredBlog2Title == "") {
        this.featuredBlog2Title = this.featuredBlogs[i].Title;
        this.featuredBlog2Summary = this.featuredBlogs[i].Summary;
        this.featuredBlog2ItemAlias = this.featuredBlogs[i].ItemAlias;

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            this.featuredBlog2ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
              if (exists) {
                // Success code
                this.featuredBlog2ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
              } else {
                // Fail code - use default
                this.featuredBlog2ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });


      } else if (this.featuredBlog3Title == "") {
        this.featuredBlog3Title = this.featuredBlogs[i].Title;
        this.featuredBlog3Summary = this.featuredBlogs[i].Summary;
        this.featuredBlog3ItemAlias = this.featuredBlogs[i].ItemAlias;

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg", (exists) => {
          if (exists) {
            // Success code
            //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            this.featuredBlog3ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".jpg";
          } else {
            // Fail code
            this.dotComService.checkIfImageExists(this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png", (exists) => {
              if (exists) {
                // Success code
                this.featuredBlog3ImageName = this.blogImagePaths + this.featuredBlogs[i].ImageName + ".png";
              } else {
                // Fail code - use default
                this.featuredBlog3ImageName = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }
    }
  }

}
